var factory_data = [
  {
    "title":"生产设备",
    "pics": [
      {"url":"AboutUs/Equipment/1.jpg"},
      {"url":"AboutUs/Equipment/2.jpg"},
      {"url":"AboutUs/Equipment/3.jpg"},
      {"url":"AboutUs/Equipment/4.jpg"},
      {"url":"AboutUs/Equipment/5.jpg"},
      {"url":"AboutUs/Equipment/6.jpg"},
      {"url":"AboutUs/Equipment/7.jpg"},
      {"url":"AboutUs/Equipment/8.jpg"}
    ]
  },{
    "title":"质量检测",
    "pics": [
      {"url":"AboutUs/Quality/1.jpg"},
      {"url":"AboutUs/Quality/2.jpg"},
      {"url":"AboutUs/Quality/3.jpg"},
      {"url":"AboutUs/Quality/4.jpg"},
      {"url":"AboutUs/Quality/5.jpg"},
      {"url":"AboutUs/Quality/6.jpg"},
      {"url":"AboutUs/Quality/7.jpg"},
      {"url":"AboutUs/Quality/8.jpg"},
      {"url":"AboutUs/Quality/9.jpg"},
      {"url":"AboutUs/Quality/10.jpg"},
      {"url":"AboutUs/Quality/11.jpg"},
      {"url":"AboutUs/Quality/12.jpg"}
    ]
  },{
    "title":"库存",
    "pics": [
      {"url":"AboutUs/Stock/1.jpg"},
      {"url":"AboutUs/Stock/2.jpg"},
      {"url":"AboutUs/Stock/3.jpg"},
      {"url":"AboutUs/Stock/4.jpg"}
    ]
  },{
    "title":"发货",
    "pics": [
      {"url":"AboutUs/Delivery/1.jpg"},
      {"url":"AboutUs/Delivery/2.jpg"},
      {"url":"AboutUs/Delivery/3.jpg"},
      {"url":"AboutUs/Delivery/4.jpg"}
    ]
  },{
    "title":"办公环境",
    "pics": [
      {"url":"AboutUs/Environment/1.jpg"},
      {"url":"AboutUs/Environment/2.jpg"}
    ]
  }

]
export default factory_data


// WEBPACK FOOTER //
// ./src/assets/data/factory_data.js